import { render, staticRenderFns } from "./EffectSummarySidebar.vue?vue&type=template&id=68f78e79&"
import script from "./EffectSummarySidebar.vue?vue&type=script&lang=js&"
export * from "./EffectSummarySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports